import React, { useEffect, useState } from 'react';
// @ts-ignore
import moment, { Moment } from 'moment';
import Calendar from './Calendar';
import CalendarPatientEventModal from './CalendarPatientEventModal';
import { workplaceWorkingHours } from '../../Modules/Workplace/Services/workplace-working-hours.service';
import { WORKPLACE_EVENTS_QUERY } from '../../Modules/Workplace/Graphql/workplace-events.query';
import apiClient from '../../Services/ApiClient';

interface IMyCalendar {
	workplaceId?: string;
}

export default function MyCalendar(props: IMyCalendar) {
	const { workplaceId } = props;

	const [detailOpened, setDetailOpened] = useState(false);
	const [selectedDate, setSelectedDate] = useState(null);
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [businessHours, setBusinessHours] = useState([]);
	const [events, setEvents] = useState([]);
	const [dateRange, setDateRange] = useState({ start: null, end: null });

	useEffect(() => {
		handleLoadWorkingHours();
		handleLoadData();
	}, [dateRange]);

	const handleLoadData = () => {
		if (!dateRange.start) {
			setEvents([]);
			return;
		}

		// @ts-ignore
		const a = async () => {
			const tempEvents = [];
			const variables = {
				start: dateRange.start.format(),
				end: dateRange.end.format(),
			};

			const { meta, data } = await apiClient.graphql({
				query: WORKPLACE_EVENTS_QUERY,
				variables,
				fetchPolicy: 'network-only',
			});

			for (const event of data.workplaceEvents.data) {
				tempEvents.push({
					id: event.id,
					title: event.title,
					start: moment(event.dateFrom).format(),
					end: moment(event.dateTo).format(),
					backgroundColor: event.layout.backgroundColor,
					borderColor: event.layout.backgroundColor,
					textColor: event.layout.fontColor,
					resourceId: 'a',
				});
			}

			setEvents(tempEvents);
		};

		a();
	};

	const handlePickDate = date => {
		setSelectedDate(date);
		setDetailOpened(true);
	};

	const handleEventClick = event => {
		setSelectedEvent(event);
		setDetailOpened(true);
	};

	const handleClose = () => {
		setSelectedEvent(null);
		setDetailOpened(false);
	};
	const handleLoadWorkingHours = () => {
		// @ts-ignore
		new Promise(async () => {
			setBusinessHours(await workplaceWorkingHours({ workplaceId }));
		}).then();
	};

	const handleDateChange = (start: Moment, end?: Moment) => {
		setDateRange({ start, end });
	};

	const handleEventDrop = event => {
		// @ts-ignore
		const a = async () => {
			await apiClient.patch(`/event/${event.id}`, {
				dateFrom: moment(event.start).format(),
				dateTo: moment(event.end).format(),
			});
		};

		a();
	};

	return (
		<>
			<Calendar
				events={events}
				onTimeClick={handlePickDate}
				onEventClick={handleEventClick}
				businessHours={businessHours}
				onDateChange={handleDateChange}
				editable={true}
				onEventDrop={handleEventDrop}
				onEventResize={handleEventDrop}
			/>
			<CalendarPatientEventModal
				opened={detailOpened}
				onClose={handleClose}
				selectedDate={selectedDate}
				workplaceId={workplaceId}
			/>
			<CalendarPatientEventModal
				opened={detailOpened}
				onClose={() => setDetailOpened(false)}
				selectedDate={selectedDate}
			/>
		</>
	);
}
